import React from 'react';

export const Recipe = ({ name, description, ingredients }) => (
    <React.Fragment>
        <h4>{name}</h4>
        {description ? <p>{description}</p> : null}
        {ingredients && ingredients.length ? <p><em>{ingredients.join(', ')}</em></p> : null}
    </React.Fragment>
);
